import { api } from './auth.service';

const planejamentoService = {

  // Lista negócios em fase técnica (browse)
  listar: async () => {
    const res = await api.get('/planejamento');
    return res.data;
  },

  // Carrega dados do projeto + itens da quantificação atual + totais
  obterDados: async (id) => {
    const res = await api.get(`/planejamento/${id}/dados`);
    return res.data;
  },

  // Atualiza horas_save de um item da quantificação (autosave)
  // Retorna o novo horas_save + horas_execucao recalculado
  atualizarHorasSave: async (itemId, horasSave) => {
    const res = await api.patch(`/planejamento/itens/${itemId}/save`, {
      horas_save: horasSave,
    });
    return res.data;
  },
};

export default planejamentoService;
